// plugins/IonicComponents.js
import {
  IonAccordion,
  IonAccordionGroup,
  IonAlert,
  IonApp,
  IonAvatar,
  IonBackButton,
  IonLoading,
  // IonBadge,
  IonButton,
  IonButtons,
  IonCard,
  IonCardContent,
  IonCardHeader,
  IonCardSubtitle,
  IonCardTitle,
  IonCheckbox,
  IonChip,
  // IonCol,
  IonContent,
  IonDatetime,
  // IonFab,
  // IonFabButton,
  // IonFabList,
  IonFooter,
  // IonGrid,
  IonHeader,
  IonIcon,
  IonImg,
  // IonInfiniteScroll,
  // IonInfiniteScrollContent,
  IonInput,
  IonItem,
  // IonItemDivider,
  // IonItemGroup,
  // IonItemOption,
  // IonItemOptions,
  IonItemSliding,
  IonLabel,
  IonList,
  IonListHeader,
  IonMenu,
  IonMenuButton,
  IonMenuToggle,
  IonModal,
  IonNav,
  // IonNote,
  IonPage,
  IonPopover,
  IonProgressBar,
  IonRadio,
  IonRadioGroup,
  IonRange,
  // IonRefresher,
  // IonRefresherContent,
  // IonReorder,
  // IonReorderGroup,
  IonRippleEffect,
  IonRouterOutlet,
  // IonRow,
  IonSearchbar,
  IonSegment,
  IonSegmentButton,
  IonSelect,
  IonSelectOption,
  IonSkeletonText,
  // IonSlide,
  // IonSlides,
  IonSpinner,
  // IonSplitPane,
  // IonTabBar,
  // IonTabButton,
  IonText,
  IonTextarea,
  // IonThumbnail,
  IonTitle,
  // IonToast,
  IonToggle,
  IonToolbar,
  IonDatetimeButton,
  IonBackdrop,
  // IonVirtualScroll
} from '@ionic/vue';
import type { App, Component } from 'vue';

export default {
  install: (app: App<Element>) => {
    // List of all the components to be registered globally
    const components: Component[] = [
      IonAccordion,
      IonAccordionGroup,
      IonAlert,
      IonApp,
      IonAvatar,
      IonBackButton,
      IonButton,
      IonButtons,
      IonCheckbox,
      IonBackdrop,
      IonChip,
      IonContent,
      IonDatetime,
      IonDatetimeButton,
      IonFooter,
      IonHeader,
      IonIcon,
      IonImg,
      IonInput,
      IonItem,
      IonItemSliding,
      IonLabel,
      IonList,
      IonListHeader,
      IonMenu,
      IonMenuButton,
      IonMenuToggle,
      IonModal,
      IonNav,
      IonPage,
      IonPopover,
      IonProgressBar,
      IonRadio,
      IonRadioGroup,
      IonRange,
      IonLoading,
      IonRippleEffect,
      IonRouterOutlet,
      IonSearchbar,
      IonSegment,
      IonSegmentButton,
      IonSelect,
      IonSelectOption,
      IonSkeletonText,
      IonSpinner,
      IonText,
      IonTextarea,
      IonTitle,
      IonToggle,
      IonToolbar,
      IonCard,
      IonCardContent,
      IonCardHeader,
      IonCardSubtitle,
      IonCardTitle,
    ];

    // Register each component globally
    components.forEach((component: Component) => {
      app.component(component.name as string, component);
    });
  },
};
